import { useEffect, useState } from "react";
import { legalAPI } from "@/lib/api";
import MarketingTopBar from "@/components/MarketingTopBar";
import FooterLinks from "@/components/FooterLinks";
import { Loader2 } from "lucide-react";

function Block({ block }) {
  const text = block.text || "";
  switch (block.type) {
    case "h1":
      return <h1 className="mt-8 font-display text-3xl font-bold uppercase tracking-wide first:mt-0 sm:text-4xl">{text}</h1>;
    case "h2":
      return <h2 className="mt-7 font-display text-2xl font-bold first:mt-0">{text}</h2>;
    case "h3":
      return <h3 className="mt-5 text-lg font-semibold first:mt-0">{text}</h3>;
    default:
      return <p className="mt-3 whitespace-pre-wrap leading-relaxed text-foreground/80">{text}</p>;
  }
}

export default function LegalPage({ slug }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    legalAPI
      .get(slug)
      .then((r) => setData(r.data))
      .catch(() => setData({ title: slug === "privacy" ? "Privacy Policy" : "Terms of Service", blocks: [] }))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <MarketingTopBar compact />
      <main className="flex-1 px-4 pb-16 pt-28 sm:px-6 sm:pt-32">
        <div className="mx-auto max-w-3xl">
          {loading ? (
            <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
          ) : (
            <>
              {(data?.blocks || []).length === 0 && (
                <h1 className="font-display text-3xl font-bold uppercase sm:text-4xl">{data?.title}</h1>
              )}
              {(data?.blocks || []).map((b, i) => (
                <Block key={i} block={b} />
              ))}
              {data?.updated_at && (
                <p className="mt-10 text-xs text-muted-foreground">
                  Last updated: {new Date(data.updated_at).toLocaleDateString()}
                </p>
              )}
            </>
          )}
        </div>
      </main>
      <footer className="border-t border-border px-4 py-8 sm:px-6">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-4">
          <img
            src="https://customer-assets-rejwkqb3.emergentagent.net/job_throttle-hub-6/artifacts/krvfdgqm_Powered%20by%20PLSR%20%28cropped%29.png"
            alt="Powered by PLSR"
            className="h-9 w-auto opacity-80"
            draggable={false}
            data-testid="footer-powered-by"
          />
          <FooterLinks tone="light" align="center" />
        </div>
      </footer>
    </div>
  );
}
